<template>
    <v-container v-if="!!itemsCount" class="mx-0 px-2 d-flex align-items-center">
        <v-menu
            v-model="menu"
            bottom
            min-width="454px"
            offset-y
            right
            :close-on-click="false"
            :close-on-content-click="false"
            class="menu-component"
        >
            <template #activator="{ on }">
                <v-icon v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            <v-card class="quick-help">
                <v-card-title>{{ t('default::title.quick_help') }}</v-card-title>
                <div class="top-actions">
                    <v-icon @click="menu = false">mdi-close</v-icon>
                </div>
                <v-list v-if="items" class="quick-help-list">
                    <template v-for="(item, index) in items">
                        <v-divider v-if="index !== 0" :key="index" class="my-2" :inset="false"></v-divider>
                        <v-list-item :key="item.title" class="quick-help-list-item">
                            <v-list-item-content class="p-0 pt-2 quick-help-list-item-wrap">
                                <v-list-item-title
                                    class="quick-help-list-item-title"
                                    v-html="item.title"
                                ></v-list-item-title>
                                <div class="quick-help-list-item-content" v-html="item.content"></div>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
            </v-card>
        </v-menu>
    </v-container>
</template>

<script>
export default {
    name: 'QuickHelpComponent',
    components: {},
    props: {
        route: {
            type: String,
            required: false,
            default: 'test.route',
        },
    },
    data() {
        return {
            menu: false,
        };
    },
    computed: {
        items() {
            return this.$store.state.quick_help.items;
        },
        itemsCount() {
            return this.$store.state.quick_help.count;
        },
    },
    watch: {},
    created() {
        if (!this.can('api.v1.help-pages.data')) {
            return;
        }
        this.$store.dispatch('quick_help/fetchHelpPage', route('api.v1.help-pages.data', this.route));
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.v-card__title {
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.07);
}
.quick-help-list {
    overflow-x: scroll;
    max-height: 420px;
}
</style>
